import { createAsyncThunk } from '@reduxjs/toolkit'
import DeviceSettings from './device-settings-model'
import {
  delete_deviceSettings,
  load_deviceSettingss,
  store_deviceSettings,
} from './deviceSettings-service'

export const LoadDeviceSettingssAsync = createAsyncThunk<any, any>(
  'composer/load/deviceSettings',
  async (params: { uid: string }) => {
    return await load_deviceSettingss(params)
  },
)

export const CreateDeviceSettingsAsync = createAsyncThunk<any, any>(
  'composer/create/deviceSettings',
  async (params: DeviceSettings) => {
    return await store_deviceSettings(params)
  },
)

export const DeleteDeviceSettingsAsync = createAsyncThunk<any, any>(
  'composer/delete/deviceSettings',
  async (params) => {
    return await delete_deviceSettings(params)
  },
)
